<section class="loggedout-page">
  <div class="logo-wrapper">
	<img class="ff-logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Fagforbundet" />
  </div>

  <div class="loggedout-content">
	<h1>Logget ut</h1>
	<p>Du er nå logget ut</p>

	<a class="button primary back-home-button" href="https://www.fagforbundet.no/" aria-label="Gå til fagforbundet.no">
	  &rarr;
	</a>
  </div>
</section>

